import { render, staticRenderFns } from "./FolderAssignCollaboratorDialog.vue?vue&type=template&id=d7d67b2e&scoped=true"
import script from "./FolderAssignCollaboratorDialog.vue?vue&type=script&lang=js"
export * from "./FolderAssignCollaboratorDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderAssignCollaboratorDialog.vue?vue&type=style&index=0&id=d7d67b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d67b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
